export enum TipoMoneda{
    PES = 0,
    USD = 1
}